// Reusable form section wrapper with title
import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface FormSectionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  style?: ViewStyle;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  subtitle,
  children,
  style,
}) => {
  return (
    <View style={[styles.section, style]}>
      <Text style={styles.title}>{title}</Text>
      {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT.PRIMARY,
    marginBottom: 16,
  },
  subtitle: {
    fontSize: 13,
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 16,
  },
});

